<template>
  <div>
    <div>
      <el-button type="primary" plain @click="addUser">新增组织</el-button>
      <!-- <el-input
        style="width: 200px"
        placeholder="机构码筛选"
        v-model="orgCode"
      ></el-input> -->
      <tree-select
        v-if="orgBack"
        :treeValue="orgCode"
        @reset="orgCode = ''"
        @treeAll="orgall"
        style="
          width: 294px;
          display: inline-block;
          vertical-align: bottom;
          font-size: 14px;
        "
        placeholder="请输入医院名称"
        :option="orgOption"
      ></tree-select>
      <el-button @click="getpage(1)">筛选</el-button>
    </div>
    <el-divider></el-divider>
    <div>
      <el-table :data="list">
        <!-- <el-table-column align="center" label="用户名">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>姓名: {{ scope.row.username }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.username }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column> -->
        <el-table-column align="center" label="机构名称">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{
              getName(scope.row.orgCode)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="机构ID">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.orgCode }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="可用次数">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.usableNum }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="开始日期">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.startTime }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="结束日期">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.endTime }}</span>
          </template>
        </el-table-column> -->
        <el-table-column align="center" label="创建日期">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="修改日期">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.updateTime }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >修改</el-button
            >

            <el-popconfirm
              title="你确定要删除该条目吗？"
              @onConfirm="handleDelete(scope.$index, scope.row)"
            >
              <el-button
                style="margin: 0 10px"
                size="mini"
                type="danger"
                slot="reference"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page
      @givePageIndex="getpage"
      :index="page"
      :pageSize="pageSize"
      :total="total"
    ></page>
    <el-dialog :title="diaName" :visible.sync="dialogVisible" width="60%">
      <el-form :inline="true" ref="form" :model="form" label-width="120px">
        <el-form-item label="机构" required>
          <tree-select
            v-if="dialogVisible"
            :treeValue="form.orgCode1"
            @reset="form.orgCode1 = ''"
            @treeAll="formorgall"
            style="
              width: 294px;
              display: inline-block;
              vertical-align: bottom;
              font-size: 14px;
            "
            placeholder="请输入医院名称"
            :option="orgOption"
          ></tree-select>
        </el-form-item>
        <!-- <el-form-item v-if="name == 'admin'" label="是否开启统计">
          <el-switch v-model="form.openStat"></el-switch>
        </el-form-item> -->
        <el-form-item label="可用次数">
          <el-input v-model.number="form.usableNum"></el-input>
        </el-form-item>
        <!-- <el-form-item label="开始时间">
          <el-date-picker
            v-model="form.startTime"
            type="date"
            size="normal"
            placeholder="选择日期时间"
            value-format="yyyy-MM-DD"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="form.endTime"
            type="date"
            size="normal"
            value-format="yyyy-MM-DD"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import treeSelect from "../../components/treeSelect";
import page from "../../components/pages";
export default {
  components: {
    treeSelect,
    page,
  },
  created() {
    this.name = sessionStorage.getItem("admin");

    this.$api.structureList().then((res) => {
      // console.log(res)
      if (res.data.code == 200) {
        this.orgBack = true;
        this.orgOption = res.data.data;

        if (this.name !== "admin") {
          this.orgCode = Number(sessionStorage.getItem("orgId"));
        } else {
          this.orgCode = undefined;
        }
        this.load();
      } else {
        this.load();
      }
    });
  },

  data() {
    return {
      grp: 0,
      orgOption: [],
      openStat: 0,
      orgBack: false,
      name: "",
      orgCode: "",
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      dialogVisible: false,
      tree: false,
      form: {
        orgCode: "", //机构id
        usableNum: "", //次数
        orgCode1: "",
      },
      diaName: "新增组织",
    };
  },
  methods: {
    //打开新增用户页面，请求树形组件内容
    addUser() {
      this.diaName = "新增组织";
      this.form = {
        orgCode1: undefined,
        orgCode: undefined,
        usableNum: "", //次数
      };
      this.dialogVisible = true;
    },
    formorgall(x) {
      this.form.orgCode = x.code;
    },
    orgall(x) {
      this.orgCode = x.code;
      // this.form.department = x.name;
    },
    getName(row) {
      return this.orgOption.find((item) => item.code == row)?.name;
    },
    add() {
      console.log(this.form);
      if (!this.form.orgCode) {
        this.$message({
          message: "请选择机构",
          type: "warning",
        });
        return;
      }
      if (!this.form.usableNum) {
        this.$message({
          message: "请输入使用次数",
          type: "warning",
        });
        return;
      }
      this.$api
        .aiOrgSave(this.form)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.load();
            this.dialogVisible = false;
          } else {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleEdit(index, row) {
      this.diaName = "修改组织";
      let org =
        this.orgOption.find((item) => item.code == row.orgCode)?.id || "1";
      this.$set(this.form, "orgCode1", org);
      this.form.orgCode = row.orgCode;
      this.form.usableNum = row.usableNum;
      this.form.startTime = row.startTime;
      this.form.endTime = row.endTime;
      this.form.id = row.id;
      this.$nextTick(() => {
        this.$forceUpdate();
        this.dialogVisible = true;
      });
    },

    //删除用户
    handleDelete(index, row) {
      console.log(row.id);
      this.$api.aiOrgDelete(row.id).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.load();
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },

    load() {
      let obj = {
        pageNo: this.page,
        pageSize: this.pageSize,
        orgCode: this.orgCode ? this.orgCode : undefined,
      };
      this.$api.aiOrgList(obj).then((res) => {
        if (res.data.code == 200) {
          this.list = res.data.data.records;
          this.page = res.data.data.current;
          this.pageSize = res.data.data.size;
          this.total = res.data.data.total;
        }
      });
    },
    getpage(x) {
      //分页
      this.page = x;
      this.load();
    },
  },
};
</script>

<style scoped>
</style>